import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { RequestService } from 'src/app/services/requestService/request.service';

@Component({
  selector: 'app-legal-page',
  templateUrl: './legal-page.component.html',
  styleUrls: ['./legal-page.component.less']
})
export class LegalPageComponent implements OnInit {
  doc;
  constructor(private router: Router, private requestService: RequestService, private languageService: LanguageService) { }

  ngOnInit(): void {
    // Get the proper legal page based on user route
    this.requestService.localGetRequest({ url: "assets/legalPages" + this.router.url + "_" + this.languageService.getLanguage() + ".html" }).then((resp: any) => {
      this.doc = resp.text;
    });
  }
}